"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
const PageableConverter_1 = require("../common/model/PageableConverter");
class ChannelsConverter {
    static convertEmbeddedResources(response) {
        return PageableConverter_1.PageableConverter.convert(response, 'channels', ChannelsConverter.convertResource);
    }
    static convertResponse(response) {
        return ChannelsConverter.convertResource(response.data);
    }
    static convertResource(resource) {
        return {
            id: resource.id,
            name: resource.name,
            currency: resource.currency,
            legalRestriction: resource.legalRestriction,
            distributionMethods: resource.distributionMethods,
            description: resource.description,
            notes: resource.notes,
            contentCategories: resource.contentCategories,
            language: resource.language,
            contentType: resource.contentType,
            oneLineDescription: resource.oneLineDescription,
            marketingInformation: resource.marketingInformation,
            pedagogyInformation: resource.pedagogyInformation,
            ingest: resource.ingest
                ? ChannelsConverter.convertIngestDetailsResource(resource.ingest)
                : undefined,
            contractId: resource.contractId,
            contractName: resource.contractName,
            taxonomy: {
                categories: resource.taxonomy?.categories,
                requiresVideoLevelTagging: resource.taxonomy?.requiresVideoLevelTagging,
            },
            educationLevels: resource.educationLevels,
            links: {
                self: !!resource._links && !!resource._links.self
                    ? new LinkEntity_1.Link(resource._links.self)
                    : undefined,
            },
        };
    }
    static convertIngestDetailsResource(resource) {
        switch (resource.type) {
            case 'MANUAL':
            case 'CUSTOM':
                return { type: resource.type };
            case 'MRSS':
                return { type: resource.type, urls: resource.urls };
            case 'YOUTUBE':
                return { type: resource.type, playlistIds: resource.playlistIds };
            default:
                throw new Error(resource.type);
        }
    }
}
exports.ChannelsConverter = ChannelsConverter;
//# sourceMappingURL=ChannelsConverter.js.map